import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_designereyes/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'

import {CatalogWrapper} from '../pages/uploadPages/CatalogWrapper'
import {ImageUploadWrapper} from '../pages/uploadPages/ImageUploadWrapper'
import {DocumentsWrapper} from '../pages/documentsPage/DocumentsWrapper'
import {ChangelogWrapper} from '../pages/changelog/changeLog'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_designereyes/assets/ts/_utils'
import {WithChildren} from '../../_designereyes/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import LiveText from '../pages/dashboard/liveText'

//apps
import {ShopifyProductAssistantWrapper} from '../pages/dashboard/Apps/ShopifyProductAssistantWrapper'
import {CollectionWriterWrapper} from '../pages/dashboard/Apps/ShopifyCollectionWriterWrapper'
import {ShopifyStoresPage} from '../pages/dashboard/admin_apps/ShopifyStoresPage'
import {AutoBloggerWrapper} from '../pages/dashboard/Apps/ShopifyAutoBloggerWrapper'
import {ShopifyManualWriterWrapper} from '../pages/dashboard/Apps/ShopifyManualWriterWrapper'
import {ShopifyReviewWriterWrapper} from '../pages/dashboard/Apps/ShopifyReviewWriterWrapper'
import { InnerLinkMapWrapper } from '../pages/dashboard/InnerLinkMapPage'
import { InnerLinkerWrapper } from '../pages/dashboard/Apps/InnerLinkerWrapper'
import { KangerWholesaleWrapper } from '../pages/dashboard/KangerWholesaleWrapper'
import {useAuth} from '../modules/auth'
import {PleasreSpotProductsWrapper} from '../pages/dashboard/PleasreSpotProductsWrapper'
import PleasureSpotCompletionWrapper from '../pages/dashboard/PleasureSpotCompletionWrapper'

const PrivateRoutes = () => {
  const { currentUser } = useAuth()
  const redirectPath = currentUser?.decoded?.email === 'testuser@gmail.com' ? '/live-text' : '/dashboard'
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      {/* Live Text page without layout */}
      <Route path='live-text' element={<LiveText />} />
      
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to={redirectPath} />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='apps/shopify-product-assistant' element={<ShopifyProductAssistantWrapper />} />
        <Route path='apps/shopify-auto-writer' element={<CollectionWriterWrapper />} />
        <Route path='admin/shopify-stores' element={<ShopifyStoresPage />} />
        <Route path='apps/auto-blogger' element={<AutoBloggerWrapper />} />
        <Route path='apps/manual-writer' element={<ShopifyManualWriterWrapper />} />
        <Route path='apps/review-writer' element={<ShopifyReviewWriterWrapper />} />
        <Route path='innerlink-map' element={<InnerLinkMapWrapper />} />
        <Route path='apps/inner-linker' element={<InnerLinkerWrapper />} />
        <Route path='apps/kanger-wholesale' element={<KangerWholesaleWrapper />} />
        <Route path='apps/pleasurespot-products' element={<PleasreSpotProductsWrapper />} />
        <Route path='apps/pleasurespot-completion' element={<PleasureSpotCompletionWrapper />} />
        {/*  */}

        <Route path='catalog' element={<CatalogWrapper />} />
        <Route path='image-upload' element={<ImageUploadWrapper />} />
        <Route path='documents123123' element={<DocumentsWrapper />} />

        {/* Pages */}

        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        <Route
          path='/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />

        <Route path='changelog' element={<ChangelogWrapper />} />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
